<template>
  <div class="background" ref="card">
    <a-card class="card">
      <div>
        <div style="text-align: center; padding-top: 16px">
          <img :src="logo" width="100" style="cursor: pointer; margin-top: 16px"/>
        </div>
        <div class="title" style="margin-top: 16px">
          <span style="cursor: pointer; font-size: 24px" @click="backIndex">羽佳农业</span>
        </div>
        <div style="text-align: center; font-size: 20px; color: #1890ff; margin-top: 8px; margin-bottom: 24px">
          <span>进销存管理系统</span>
        </div>
      </div>
      <router-view />
    </a-card>
  <div class="loginBoxBottom">
      <div class="login-copyright">
        <div class="bottom">
          <p>
            备案号；<a
              href="https://beian.miit.gov.cn/"
              target="“_blank”"
              >京ICP备19013355号-3</a
            >
          </p>
        </div>
      </div>
    </div>
   </div>
</template>

<script>
export default {
  name: "UserLayout",
  data() {
    return {
      logo: require("@/assets/logo.png"),
    };
  },
  // methods: {
  //   backIndex() {
  //     window.open("http://www.himool.com", "_self");
  //   },
  // },
};
</script>

<style scoped>
.card {
  width: 480px;
  border-radius: 8px;
  padding-bottom: 64px;
  margin: auto;
}

.background {
  min-height: 100%;
  padding: 10vh 0;
  background: #f0f2f5 url("~@/assets/background.svg") no-repeat 50%;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #1890ff;
  margin-top: 8px;
  font-weight: bold;
}
.loginBoxBottom {
  /* width: calc(100vw - 700px); */
  width: 100%;
  position: absolute;
  bottom: 50px;
}
.login-copyright {
  color: #999;
  text-align: center;
  line-height: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-copyright .bottom {
  display: flex;
  justify-content: center;
}
.login-copyright .top {
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.login-copyright .bottom div a {
  color: inherit;
}

.login-copyright .bottom p {
  margin: 0;
  font-size: 14px;
}

.login-copyright .bottom .blue {
  font-size: 11px;
  color: #316aff;
}
.login-copyright .bottom a,
.login-copyright .bottom a:hover {
  color: #999;
}
</style>
